export const API_URL = 'http://localhost:8080';
export const PARSE_APPLICATION_ID =
  'DwjY3wpxaUUR2Ehd4acfuRATcHuei7sPr4aHhUUjGB';
export const NETWORK_REQUEST_TIMEOUT_IN_MILLIS = 60000;
export const VIDEA_BEACON_URL = 'ws://localhost:8090/Watcher';
export const BUILD_CONFIGURATION = 'NON_FDA';
export const OKTA_DOMAIN = 'https://login.dev.videahealth.io';
export const OKTA_CLIENT_ID = '0oa1o0y7e3DcN8fCL5d7';
export const DEX_CONVERSION_API_URL = 'https://dex-api.dev.videahealth.io';

export const MIXPANEL_TOKEN = '5c3678b90b279d92d8f6c02d598adf97';
export const USERPILOT_TOKEN = 'STG-NX-2caf528a';
export const LANGFUSE_PUBLIC_KEY = 'pk-lf-0fa6a25f-be63-471c-be60-47f5e06038f3';
export const LANGFUSE_NOTES_PUBLIC_KEY = 'pk-lf-df815ec6-e76b-4341-b433-16454b1075c9';
export const LANGFUSE_BASE_URL = 'https://langfuse.synapse.dev.videahealth.io';
export const OPS_DASHBOARD_SHOW_WATCHLIST = false;

export const PARENT_WINDOW_EMBED_URL = 'http://localhost:5174';

// Keycloak / Synapse authentication (use dev for local development)
export const AMBIENT_API_URL = 'https://ambient.api.synapse.dev.videahealth.io';
export const KEYCLOAK_URL = 'https://keycloak.api.synapse.dev.videahealth.io';
export const KEYCLOAK_REALM = 'synapse';
export const KEYCLOAK_CLIENT_ID = 'synapse-spa';
export const SYNAPSE_TOKEN_URL =
  'https://token.external.synapse.dev.videahealth.io';
